import { DecimalPipe } from "@angular/common";
import { Component, Input, Output, EventEmitter, OnChanges } from "@angular/core";
import { LogService } from "@rubbl-core";
import { CountValueFacetItem } from "@rubbl-search-results";

@Component({
  selector: "app-facet-checkbox-group",
  templateUrl: "./facet-checkbox-group.component.html",
  styleUrls: ["./facet-checkbox-group.component.scss"],
})
export class FacetCheckboxGroupComponent implements OnChanges {
  @Input() facetGroup: CountValueFacetItem[];
  @Input() facetSubGroup: CountValueFacetItem[] = [];
  @Input() facetName: string;
  @Input() unit: string = "";
  @Input() useSingleState: boolean = false; // this is the flag to show the single state when there is only one facet in the facet grou
  @Input() useLabelWhenOne: boolean = false;
  @Input() appendSubFacetToFacet: boolean = true;
  @Input() useCommas: boolean = false;
  @Input() useShowMoreFunctionality: boolean = true;
  @Input() showBorderBottom: boolean = true;
  @Input() icon: string;

  cachedFacetGroup: CountValueFacetItem[];
  lessMoreText: string;

  @Output() checkboxChange = new EventEmitter();

  constructor(private decimalPipe: DecimalPipe, private logService: LogService) {}

  ngOnChanges() {
    if (this.facetName == "Attachment") {
      this.facetGroup.sort((a, b) => a.label.trim()["trimLeft"]().localeCompare(b.label.trim()["trimLeft"]()));
    }

    this.lessMoreText = "";
    if (this.useShowMoreFunctionality && this.facetGroup.length > 6) {
      // we need to check if any of the facets after the length of 6 are checked.
      // if so we need to show all facets
      // otherwise hide the other
      const toBeHiddenFacets = this.facetGroup.slice(6, this.facetGroup.length - 1);
      if (toBeHiddenFacets.some(d => d.checked)) {
        this.cachedFacetGroup = this.facetGroup;
        this.showMoreFacets();
      } else {
        this.showLessFacets();
      }
    }
  }

  onChange(checked, label) {
    if (checked) {
      this.logService.pushTagToGtm({ event: "searchFilter", filterCategory: this.facetName, filterSelection: label });
    }
    this.checkboxChange.emit();
  }

  showMoreFacets() {
    this.facetGroup = this.cachedFacetGroup;
    this.lessMoreText = "less";
  }

  showLessFacets() {
    this.cachedFacetGroup = this.facetGroup;
    this.facetGroup = this.facetGroup.slice(0, 6);
    this.lessMoreText = "more";
  }

  getSubFacets(value: string) {
    return this.facetSubGroup.filter(subFacet => subFacet.parentValue === value);
  }

  getCheckboxLabel(facet: CountValueFacetItem, subFacets: CountValueFacetItem): string {
    const facetCount = `<span class='ml-auto fs-14 font-weight-light text-grey'>(${facet.count})</span>`;
    if (facet.label && facet.count) {
      if (facet.label === "Buy It Now") {
        return `<i class="icon-earnings text-primary fs-24 mr-2"></i>${facet.label} ${facetCount}`;
      }

      if (facet.label == "Top Owner") {
        return `<i class="icon-rubbl top-owner-icon-facets mr-2" style='color: #fdaf09;'></i>${facet.label} ${facetCount}`;
      }
      return `${facet.label} ${facetCount}`;
    }

    if (facet.label) {
      return facet.label;
    }

    if (typeof facet.value === "number") {
      return `${this.decimalPipe.transform(facet.value)} ${this.unit}`;
    }

    return `${facet.value} ${this.unit} ${facetCount}`;
  }
}
